module.exports = __webpack_public_path__ + "assets/img/3-1.2873d2c9.png";